import {useSelector} from 'react-redux';
import React from 'react';

import Checkbox from '../../../elements/forms/Checkbox';
import ListItem from '../../../elements/DEPRECATED_ListItem';
import eventHumanFriendlyDate from '../../../../misc/eventHumanFriendlyDate';

const EventListingStatus = props => {
    const {event, perEvent, onChange} = props,
        defaultValue = useSelector(state => state.events[event.id].userEvent.listing_status),
        currentValue = perEvent.find(item => item.event_id == event.id),
        listingStatus = currentValue ? currentValue.listing_status : defaultValue;

    const handleChange = isChecked => {
        onChange([
            ...perEvent.filter(item => item.event_id != event.id),
            {
                event_id: event.id,
                listing_status: isChecked ? 1 : 0,
            },
        ]);
    };

    return (
        <Checkbox checked={listingStatus == 1} onChange={handleChange}>
            <ListItem tagName="div" icon={event.icon_url}>
                <div className="event">{event.name}</div>
                <div className="date">{eventHumanFriendlyDate(event, event.start_utc, event.end_utc)}</div>
            </ListItem>
        </Checkbox>
    );
};

export default EventListingStatus;
